import { render, staticRenderFns } from "./KjpTable.vue?vue&type=template&id=4507b25d&scoped=true&"
import script from "./KjpTable.vue?vue&type=script&lang=js&"
export * from "./KjpTable.vue?vue&type=script&lang=js&"
import style0 from "./KjpTable.vue?vue&type=style&index=0&id=4507b25d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507b25d",
  null
  
)

export default component.exports